export function getServiceWorkerRegistration() {
	const serviceWorkerScope = window.location.pathname.endsWith("/")
		? window.location.pathname
		: `${window.location.pathname}/`;
	return navigator.serviceWorker.getRegistration(serviceWorkerScope);
}
